import { render, staticRenderFns } from "./goodsList.vue?vue&type=template&id=1fa20a77&scoped=true"
import script from "./goodsList.vue?vue&type=script&lang=ts"
export * from "./goodsList.vue?vue&type=script&lang=ts"
import style0 from "./goodsList.vue?vue&type=style&index=0&id=1fa20a77&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa20a77",
  null
  
)

export default component.exports